// extracted by mini-css-extract-plugin
export default {"top":"Workspace_window_top__x+kMh","bottom":"Workspace_window_bottom__bLfU8"};